import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ChangeElementTypologyDialog,
  FormSubmitButtons,
  GridWrap,
  InfoWrapper,
  RHFSelect,
  RHFTagAutocomplete,
} from 'components';
import { tipologiaSolettaOptions } from 'constants/selectOptions';
import { INFO } from 'pages/Inspections/config/info';
import { resetObjectSchedaIspezione } from 'utils/Inspections/L1/resetSchedaIspezione';
import useSchedaDifetti from 'utils/Inspections/L1/schedeDifetti';
import { isNullOrUndefinedOrEmptyString } from 'utils/utilities';

const SoletteForm = ({
  soletteFields,
  selected,
  setSelected,
  soletteTable,
  selectedIdx,
}) => {
  const { getValues, setValue } = useFormContext({
    defaultValues: {
      soletteTableValue: [],
      tipologiaSolettaTableValue: '',
    },
  });

  const { populateSchedaDifetti } = useSchedaDifetti();

  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

  useEffect(() => {
    setValue('soletteTableValue', selected);
  }, [selected]);

  useEffect(() => {
    onResetSolette();
  }, [selectedIdx]);

  const changeAutocomplete = value => {
    setSelected(value);
  };

  const changeSolette = () => {
    const tipologiaSolettaTableValue = getValues('tipologiaSolettaTableValue');

    const ids = selected.map(el => el.codice);

    const solette = [...soletteFields];

    solette.map((x, index) => {
      if (ids.includes(x?.codice)) {
        solette[index] = {
          ...x,
          tipologiaSoletta: tipologiaSolettaTableValue,
          ...(tipologiaSolettaTableValue !== x.tipologiaSoletta
            ? {
                ...resetObjectSchedaIspezione,
                schedaDifetti: populateSchedaDifetti(
                  'soletta',
                  tipologiaSolettaTableValue
                ).map(el => {
                  return {
                    ...el,
                    visto: false,
                    statoDifetto: '',
                    estensioneDifetto: '',
                    intensitaDifetto: '',
                    ps: false,
                    note: '',
                    media: [],
                  };
                }),
              }
            : null),
        };
      }
    });

    setValue(soletteTable, solette);
    onResetSolette();
  };

  const onConfirmChangeSolette = () => {
    setOpenConfirmationDialog(false);
    changeSolette();
  };

  const onSubmitSolette = () => {
    const tipologiaSolettaTableValue = getValues('tipologiaSolettaTableValue');

    const ids = selected.map(el => el.codice);

    const solette = [...soletteFields];

    const hasChangedTipologia = solette.some(el => {
      if (ids.includes(el?.codice)) {
        return (
          tipologiaSolettaTableValue !== el.tipologiaSoletta &&
          !isNullOrUndefinedOrEmptyString(el.tipologiaSoletta)
        );
      }
    });

    if (hasChangedTipologia) {
      setOpenConfirmationDialog(true);
    } else {
      changeSolette();
    }
  };

  const onResetSolette = () => {
    setValue('soletteTableValue', []);
    setValue('tipologiaSolettaTableValue', '');
    setSelected([]);
  };

  return (
    <>
      <GridWrap container spacing={2} mt={2}>
        <InfoWrapper size={3} infoMessage={INFO.soletteSelezionate.infoMessage}>
          <RHFTagAutocomplete
            multiple={true}
            id="tags-solette"
            name={'soletteTableValue'}
            changeAutocomplete={value => {
              changeAutocomplete(value);
            }}
            labelName={'option.codice'}
            getOptionLabel={option => option.codice}
            opt={soletteFields?.filter(
              el => !selected?.some(s => s?.id === el?.id)
            )}
            label="Solette selezionate"
          />
        </InfoWrapper>
        <GridWrap item xs={3}>
          <RHFSelect
            name="tipologiaSolettaTableValue"
            label="Tipologia Soletta"
            defaultValue={''}
            onChange={e => {
              setValue('tipologiaSolettaTableValue', e.target.value);
            }}
            selectOptions={tipologiaSolettaOptions}
          />
        </GridWrap>
        <GridWrap item xs={6} alignSelf="center">
          <FormSubmitButtons
            onSubmit={onSubmitSolette}
            onReset={onResetSolette}
          />
        </GridWrap>
      </GridWrap>
      <ChangeElementTypologyDialog
        open={openConfirmationDialog}
        onClose={() => setOpenConfirmationDialog(false)}
        onConfirm={onConfirmChangeSolette}
      />
    </>
  );
};
SoletteForm.propTypes = {
  soletteFields: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      codice: PropTypes.string,
      tipologiaSoletta: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
    })
  ),
  selected: PropTypes.array,
  setSelected: PropTypes.func,
  soletteTable: PropTypes.string,
  selectedIdx: PropTypes.number,
};

export default SoletteForm;
